import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import { AnimatedMessaging } from 'signup-components/styles/MessagingAnimations.styles';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { useResponsiveDims } from '../responsiveness/useResponsiveDims';
import { getMessage } from './MESSAGE';
import { KOALA, LORAX } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuoteComponentStyled = styled.div.withConfig({
  displayName: "QuoteComponent__QuoteComponentStyled",
  componentId: "sc-1cyhp07-0"
})(["text-align:center;"]);
const QuoteComponentQuoteStyled = styled.blockquote.withConfig({
  displayName: "QuoteComponent__QuoteComponentQuoteStyled",
  componentId: "sc-1cyhp07-1"
})(["position:relative;border-top:2px solid ", ";border-bottom:2px solid ", ";padding:2rem;margin:0 0 2rem 0;&::before{content:'\\201C';font-size:100px;height:50px;width:100px;line-height:1;background:white;position:absolute;top:-25px;left:50%;transform:translateX(-50%);z-index:1;color:", ";}&::after{content:'\\201D';font-size:100px;height:50px;width:100px;line-height:1;background:white;position:absolute;bottom:-25px;left:50%;transform:translateX(-50%);z-index:1;color:", ";}"], KOALA, KOALA, LORAX, LORAX);
const QuoteComponentAuthorName = styled.div.withConfig({
  displayName: "QuoteComponent__QuoteComponentAuthorName",
  componentId: "sc-1cyhp07-2"
})(["font-weight:600;text-transform:uppercase;"]);
const QuoteComponentMessage = styled(FormattedHTMLMessage).withConfig({
  displayName: "QuoteComponent__QuoteComponentMessage",
  componentId: "sc-1cyhp07-3"
})(["font-size:1.25rem;line-height:1.75rem;"]);
export const QuoteComponent = ({
  messageKey
}) => {
  const {
    imageUrl,
    imageHeights,
    altText
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(imageUrl);
  const height = useResponsiveDims(imageHeights);
  const quoteMessage = `message.${messageKey}.quoteText`;
  useEffect(() => {
    if (!imageUrl) {
      handleImageLoaded();
    }
  });
  return /*#__PURE__*/_jsx(QuoteComponentStyled, {
    children: /*#__PURE__*/_jsxs(AnimatedMessaging, {
      disable: isTransitionAndAnimationsDisabled(),
      loaded: imageLoaded,
      children: [/*#__PURE__*/_jsx(QuoteComponentQuoteStyled, {
        children: /*#__PURE__*/_jsx(QuoteComponentMessage, {
          message: quoteMessage
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(QuoteComponentAuthorName, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `message.${messageKey}.author`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `message.${messageKey}.authorTitle`
          })
        })]
      }), imageUrl && /*#__PURE__*/_jsx(UIImage, {
        alt: altText,
        responsive: true,
        src: imageUrl,
        style: {
          height,
          margin: 'auto'
        },
        onLoad: handleImageLoaded
      })]
    })
  });
};